export const parsePercentageInput = (value) => {
    if (value === "" || value === null || typeof value === "undefined") {
        return null;
    }

    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
        return null;
    }

    return Math.min(100, Math.max(0, Number(numericValue.toFixed(2))));
};

/**
 * The rate to pre-fill the settlement card with.
 *
 * THE DASHBOARD NO LONGER OWNS A DEFAULT. It used to carry
 * `DEFAULT_DELIVERY_PERCENTAGE = 15` and `DEFAULT_VENDOR_PERCENTAGE = 5`, and
 * so did the driver app, and so did the API once the wallet existed — three
 * copies of one business rule, and the vendor one did not even match the data.
 *
 * The API now resolves it and sends `effective_shipping_percentage` /
 * `effective_order_percentage` beside the raw column. Pass that as
 * `effectivePercentage`; this only decides between the row's own rate and the
 * rate the server already worked out.
 *
 * @param {number|null} persistedPercentage The row's own rate, or null.
 * @param {number|null|undefined} effectivePercentage What the API resolved.
 * @returns {number|null} null only when the API sent nothing to fall back on.
 */
export const getBaselinePercentage = (persistedPercentage, effectivePercentage) => {
    if (persistedPercentage !== null && persistedPercentage !== undefined) {
        return persistedPercentage;
    }

    return parsePercentageInput(effectivePercentage);
};

/**
 * A baseline as a value for the input box.
 *
 * `String(null)` is `"null"`, and `Number("null")` is NaN — which is how the
 * settlement card came to show «NaN% × 44,319.61». The box takes an empty
 * string for "nothing to pre-fill", never a stringified null.
 *
 * @param {number|null|undefined} baseline
 * @returns {string}
 */
export const toPercentageInputValue = (baseline) =>
    baseline === null || baseline === undefined ? "" : String(baseline);

export const formatStatNumber = (value) => {
    return Number(value || 0).toLocaleString(undefined, {
        maximumFractionDigits: 2,
    });
};
